function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createStore as e, createEvent as r, is as o, createNode as t, withRegion as a, createEffect as i, sample as n, guard as f, forward as s, clearNode as u } from "effector";
var l = new Map(),
    d = r();

function p(p) {
  return function (y) {
    return function (_ref) {
      var p = _ref.adapter,
          y = _ref.store,
          _ref$source = _ref.source,
          k = _ref$source === void 0 ? y : _ref$source,
          _ref$target = _ref.target,
          c = _ref$target === void 0 ? y : _ref$target,
          _ref$clock = _ref.clock,
          m = _ref$clock === void 0 ? k : _ref$clock,
          v = _ref.done,
          _ref$fail = _ref.fail,
          g = _ref$fail === void 0 ? d : _ref$fail,
          h = _ref.finally,
          w = _ref.pickup,
          x = _ref.key,
          _ref$keyPrefix = _ref.keyPrefix,
          P = _ref$keyPrefix === void 0 ? "" : _ref$keyPrefix;
      if (!p) throw Error("Adapter is not defined");
      if (!k) throw Error("Store or source is not defined");
      if (!c) throw Error("Target is not defined");
      if (!x && k.shortName === k.id) throw Error("Key or name is not defined");
      if (k === c && !o.store(k)) throw Error("Source must be different from target");

      var E = x || k.shortName,
          M = function (r, o) {
        var t = l.get(r);
        void 0 === t && (t = new Map(), l.set(r, t));
        var a = t.get(o);
        return void 0 !== a || (a = e(null, {
          serialize: "ignore"
        }), t.set(o, a)), a;
      }(p.keyArea || p, P + E),
          b = t(),
          A = function A() {
        return u(b);
      },
          D = function D(e) {
        return function (_ref2) {
          var r = _ref2.status,
              o = _ref2.params,
              t = _ref2.result,
              a = _ref2.error;
          return "done" === r ? {
            status: r,
            key: E,
            keyPrefix: P,
            operation: e,
            value: "get" === e ? t : o
          } : {
            status: r,
            key: E,
            keyPrefix: P,
            operation: e,
            value: o,
            error: a
          };
        };
      };

      return a(b, function () {
        var e = i(),
            o = i(),
            t = r(),
            a = t.filterMap(function (_ref3) {
          var e = _ref3.status,
              r = _ref3.key,
              o = _ref3.keyPrefix,
              t = _ref3.operation,
              a = _ref3.value;
          return "done" === e ? {
            key: r,
            keyPrefix: o,
            operation: t,
            value: a
          } : void 0;
        }),
            u = t.filterMap(function (_ref4) {
          var e = _ref4.status,
              r = _ref4.key,
              o = _ref4.keyPrefix,
              t = _ref4.operation,
              a = _ref4.error,
              i = _ref4.value;
          return "fail" === e ? {
            key: r,
            keyPrefix: o,
            operation: t,
            error: a,
            value: i
          } : void 0;
        }),
            l = p(P + E, e);
        e.use(l.get), o.use(l.set);
        var d = r();
        n({
          source: k,
          clock: m,
          target: d
        }), f({
          source: n(M, d, function (e, r) {
            return [r, e];
          }),
          filter: function filter(_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                e = _ref6[0],
                r = _ref6[1];

            return e !== r;
          },
          target: o.prepend(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 1),
                e = _ref8[0];

            return e;
          })
        }), s({
          from: [e.doneData, o],
          to: M
        }), s({
          from: [e.doneData, M],
          to: c
        }), s({
          from: [e.finally.map(D("get")), o.finally.map(D("set"))],
          to: t
        }), s({
          from: u,
          to: g
        }), v && s({
          from: a,
          to: v
        }), h && s({
          from: t,
          to: h
        }), w ? s({
          from: w,
          to: e.prepend(function () {})
        }) : e();
      }), A.unsubscribe = A;
    }(_objectSpread(_objectSpread({}, p), y));
  };
}

d.watch(function (e) {
  return console.error(e.error);
});
var y = p();
export { p as createPersist, y as persist };